export default __webpack_public_path__ + "static/media/brandpool_v2.9c0a1505.jpg";